import { getAppLang, getProperty, getUserToken } from "../../../../utils";
import axios from "axios";
import {
  CPA_GROUP_GET,
  CPA_GROUP_SYNC,
  CPA_GROUP_MAPPING_GET,
  CPA_GROUP_MAPPING_SYNC
} from "../../../../constants/api.constants";

// Get Competitor Groups
export function getCpaGroup(property_id) {
  const requestOptions = {
    headers: {
      "Content-Type": "application/json",
      authToken: getUserToken(),
      language: getAppLang(),
    },
    body: {
      params: {
        property_id: property_id ?? getProperty(),
      },
    },
  };

  return dispatch => {
    dispatch({ type: "CPA_GROUP_GET_PENDING" });
    return axios
      .post(CPA_GROUP_GET, requestOptions.body, { headers: requestOptions.headers })
      .then(response => {
        dispatch({ type: "CPA_GROUP_GET_FULFILLED", payload: response.data.data });
      })
      .catch(error => {
        dispatch({ type: "CPA_GROUP_GET_REJECTED", payload: error });
      });
  };
}

// Sync Competitor Group (Create/Update)
export function syncCpaGroup({ property_id, name, id }) {
  const params = { property_id, name };
  if (id !== undefined) params.id = id;
  const requestOptions = {
    headers: {
      "Content-Type": "application/json",
      authToken: getUserToken(),
      language: getAppLang(),
    },
    body: { params },
  };

  return dispatch => {
    dispatch({ type: "CPA_GROUP_SYNC_PENDING" });
    return axios
      .post(CPA_GROUP_SYNC, requestOptions.body, { headers: requestOptions.headers })
      .then(response => {
        dispatch({ type: "CPA_GROUP_SYNC_FULFILLED", payload: response.data.data });
      })
      .catch(error => {
        dispatch({ type: "CPA_GROUP_SYNC_REJECTED", payload: error });
      });
  };
}

// Get Competitor Group Mapping
export function getCpaGroupMapping({ property_id, competitor_group_id }) {
  const requestOptions = {
    headers: {
      "Content-Type": "application/json",
      authToken: getUserToken(),
      language: getAppLang(),
    },
    body: {
      params: {
        property_id: property_id ?? getProperty(),
        competitor_group_id,
      },
    },
  };

  return dispatch => {
    dispatch({ type: "CPA_GROUP_MAPPING_GET_PENDING" });
    return axios
      .post(CPA_GROUP_MAPPING_GET, requestOptions.body, { headers: requestOptions.headers })
      .then(response => {
        dispatch({ type: "CPA_GROUP_MAPPING_GET_FULFILLED", payload: response.data.data });
      })
      .catch(error => {
        dispatch({ type: "CPA_GROUP_MAPPING_GET_REJECTED", payload: error });
      });
  };
}

// Sync Competitor Group Mapping
export function syncCpaGroupMapping({ property_id, competitor_group_id, competitor }) {
  const requestOptions = {
    headers: {
      "Content-Type": "application/json",
      authToken: getUserToken(),
      language: getAppLang(),
    },
    body: {
      params: {
        property_id,
        competitor_group_id,
        competitor,
      },
    },
  };

  return dispatch => {
    dispatch({ type: "CPA_GROUP_MAPPING_SYNC_PENDING" });
    return axios
      .post(CPA_GROUP_MAPPING_SYNC, requestOptions.body, { headers: requestOptions.headers })
      .then(response => {
        dispatch({ type: "CPA_GROUP_MAPPING_SYNC_FULFILLED", payload: response.data.data });
      })
      .catch(error => {
        dispatch({ type: "CPA_GROUP_MAPPING_SYNC_REJECTED", payload: error });
      });
  };
}
